import { render } from "./ServiceAgree.vue?vue&type=template&id=3df1af28&scoped=true"
const script = {}

import "./ServiceAgree.vue?vue&type=style&index=0&id=3df1af28&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.31_vue@3.4.31_typescript@5.6.2__webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df1af28"]])

export default __exports__